module.exports = __webpack_public_path__ + "img/bg-smooth-mobile.b0c7eb94.png";